import React from 'react';

import { IconPipedrive } from '@paretogroup/tess';
import { Paragraph } from '../integration-strategies/modal-strategy/modal-strategy.styles';

import {
    SLOT_TITLE,
    MODAL_TITLE,
    MODAL_SUBTITLE_INITIAL,
    MODAL_SUBTITLE_FINAL,
    API_TOKEN_LINK,
    TEST_ID,
} from './pipedrive.constants';
import { Pipedrive } from './pipedrive-modal';
import { features } from '../../feature-toggle/feature-toggle.constants';
import { createFeatureToggleModalIntegration } from '../integration-strategies';
import { ICON_SIZE, TEXTS } from '../integrations.constants';

const Subtitle = () => (
    <Paragraph>
        { MODAL_SUBTITLE_INITIAL }
        <a href={API_TOKEN_LINK} target="_blank" rel="noopener noreferrer">{ MODAL_SUBTITLE_FINAL }</a>
    </Paragraph>
);

export const pipedriveIntegration = createFeatureToggleModalIntegration({
    id: 'pipedrive',
    title: SLOT_TITLE,
    icon: <IconPipedrive
        size={ICON_SIZE}
    />,
    testId: TEST_ID,
    feature: features.reportIntegration,
    modal: {
        title: MODAL_TITLE,
        subtitleComponent: Subtitle,
        body: Pipedrive,
    },
    dataAppcuesId: 'pipedrive-slot',
    subtitle: TEXTS.MAINTENANCE,
});
